import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';


import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';
import { RolresponsaveisService } from '../../../../providers/rolresponsaveis-service';
import { CargoService } from '../../../../providers/cargo-service';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

declare var jsPDF: any;

@Component({
    selector: 'page-quadro-nomeacao-cargos',
    templateUrl: 'quadro-nomeacao-cargos.html',
    providers: [
        PessoalService
    ]
})
export class PessoalQuadroNomeacaoCargosPage extends ModulosController {
    listaDados: any = [];
    listaTiposVinculos: any = [];
    listaCargo: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "110";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];

    dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    cpfPreenchido: boolean = false;
    cpfCarregado: boolean = true;
    cpfInvalido: boolean = false;
    exibirBotaoCarregarQuadroAnterior: boolean = true;
    selecionarTodosChecked = false;

    objetoEdit: any = null;
    listEdit: any = [];

    page1: number = 1;

    nomeacaoParaAdicionar: any = {
        dtEdital: '',
        dtResultado: '',
        dtHomologacao: '',
        dtNomeacao: '',
        dtExoneracao: '',
        nomeCargo: '',
        dsGrupoCargo: '',
        dsNome: '',
        cpf: '',
        dtContratacao: '',
        dtDemissao: '',
        setorLocacao: ''
    }

    myDatePickerEditalOptions: IMyDpOptions;
    myDatePickerResultadoOptions: IMyDpOptions;
    myDatePickerHomologacaoOptions: IMyDpOptions;
    myDatePickerNomeacaoOptions: IMyDpOptions;
    myDatePickerExoneracaoOptions: IMyDpOptions;
    myDatePickerContratacaoOptions: IMyDpOptions;
    myDatePickerDemissaoOptions: IMyDpOptions;

    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    filtros: any = { cpf: '' };    
    listaFiltrada: any = [];

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        private fileService: FileService,
        public cargoService: CargoService,
        public gestaoPcaService: GestaoPcaService,
        public rolService: RolresponsaveisService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        this.myDatePickerEditalOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        this.myDatePickerResultadoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false,
            componentDisabled: false
        };

        this.myDatePickerHomologacaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false,
            componentDisabled: false
        };

        this.myDatePickerNomeacaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false,
            componentDisabled: false
        };

        this.myDatePickerExoneracaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false,
            componentDisabled: false
        };

        this.myDatePickerContratacaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        this.myDatePickerDemissaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false,
            componentDisabled: false
        };

        this.carregarDados();
        this.setModuloId(11);
    }

    carregarDados() {
        this.pessoalService.listarQuadroNomeacao().subscribe(data => {
            this.listaDados = data;
            this.filtrar();
            this.loading = false;
            this.exibirBotaoCarregarQuadroAnterior = true;

            if (this.listaDados.length == 0) {
                this.exibirBotaoCarregarQuadroAnterior = false;
           }

            this.selecionarTodosChecked = false;

        }, error => {
            console.log("erro: " + error);
            this.loading = false;
            this.exibirBotaoCarregarQuadroAnterior = true;
        });

        this.pessoalService.listarGrupoCargo().subscribe(data => {
            this.listaTiposVinculos = data;
        }, error => {
            console.log("erro: " + error);
        });

        this.cargoService.listarCargoAtivo(11).subscribe(data => {
            this.listaCargo = data;
        }, error => {
            console.log("erro: " + error);
        });
    }

    fileChange(event) {        
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", 
            callback => {            
                if (callback) {  
                    this.loading = true;              
                    this.fileService.cargaQuadroNomeacaoCargos(event, this.idSecaoPagina).subscribe(data => {
                        this.inputFileCMVar.nativeElement.value = "";                       
                        this.dadosImportados = data;

                        let msgErro = '';
                        
                        for (let j = 0; j < this.dadosImportados.length; j++) {

                            let pessoa = this.dadosImportados[j];
                            pessoa.checked = true;

                            if(!this.validaCargoComissionado(pessoa, false)){
                                msgErro += '- Inconsistência em Cargo Comissionado relacionado ao CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item.<br />";
                            }                
                            
                            /*
                            if (this.temCadastroComDatasConflitantes(pessoa)) {
                                msgErro += '- Período de nomeação/contratação inconsistente relacionado ao CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item.<br />";
                            }
                            */                            
                            
                        }

                        if (msgErro == '') {
                            for (let j = 0; j < this.dadosImportados.length; j++) {
                                this.listaDados.push(this.dadosImportados[j]);
                            }
                            this.filtrar();
                            this.alertService.mostraAlerta("Importação concluída","Para efetivar a importação, clique em salvar ou finalizar.");
                        } else {
                            this.alertService.mostraAlerta("Ocorreu um erro ao importar", msgErro);
                        }
                        this.loading = false;   
                        
                    }, error => {
                        this.inputFileCMVar.nativeElement.value = "";
                        this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
                        this.loading = false;
                    });
                } else {
                    this.inputFileCMVar.nativeElement.value = "";
                }
        });
    }

    onCPFAlterado() {
        if (this.validarCPF(this.nomeacaoParaAdicionar.cpf)) {
            this.cpfInvalido = false;
        }
        else {
            this.cpfPreenchido = false;
        }
    }

    cpf_mask(v) {
        if (v) {
            v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        }
        return v;
    }

    validarCPF(cpf) {
        let ehValido = true;

        cpf = cpf.replace(/[^\w\s]/gi, '');

        if (cpf == '') {
            this.cpfInvalido = false;
            return false;
        }

        if (cpf.length != 11) {
            this.cpfInvalido = false;
            return false;
        }

        // Elimina CPFs invalidos conhecidos
        if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
            cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
            cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 1o digito
        let add = 0;
        for (let i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(9))) {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(10))) {
            this.cpfInvalido = true;
            return false;
        }

        return ehValido;
    }

    downloadDoModelo() {
        let idTemplate = 2;

        this.fileService.downloadModeloCargaPessoal(idTemplate);
    }

    baixarTemplatePreenchido(isAnterior) {
        this.loading = true;
        this.pessoalService.baixarTemplatePreenchido(isAnterior).subscribe(data => {
            let contentType = "data:" + data.mimeType + ";base64";
    
            let byteCharacters = atob(data.decodedFile);
    
            let byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
    
            var byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], { type: contentType });
            saveAs(file, data.filename);
            
            this.loading = false;

        }, error => {
            this.alertService.mostraAlerta("Houve um erro ao baixar o arquivo.", error.mensagem);
            this.loading = false;
        });
    }

    adicionarNomeacao() {

        if (this.nomeacaoParaAdicionar.dsGrupoCargo == 'Terceirizados') {
            if (this.nomeacaoParaAdicionar.dtContratacao == '') {
                this.alertService.mostraAlerta("","Informe a Data Contratação.");
                return;
            } 
        } else {
            if (this.nomeacaoParaAdicionar.dtNomeacao == '') {
                this.alertService.mostraAlerta("","Informe a data DOE Nomeação.");
                return;
            }
        }

        if (!this.cpfInvalido) {
            
            if (this.nomeacaoParaAdicionar.dsGrupoCargo != '' 
                && this.nomeacaoParaAdicionar.nomeCargo != ''
                && this.nomeacaoParaAdicionar.dsNome != '') {

                let nomeacaoNovo = {
                    "idQuadroNomeacaoCargos": 0,
                    "dtEdital": this.nomeacaoParaAdicionar.dtEdital,
                    "dtResultado": this.nomeacaoParaAdicionar.dtResultado,
                    "dtHomologacao": this.nomeacaoParaAdicionar.dtHomologacao,
                    "dtNomeacao": this.nomeacaoParaAdicionar.dtNomeacao,
                    "dtExoneracao": this.nomeacaoParaAdicionar.dtExoneracao,
                    "dtContratacao": this.nomeacaoParaAdicionar.dtContratacao,
                    "dtDemissao": this.nomeacaoParaAdicionar.dtDemissao,
                    "setorLocacao": this.nomeacaoParaAdicionar.setorLocacao,
                    "dsNome": this.nomeacaoParaAdicionar.dsNome,
                    "cpf": this.nomeacaoParaAdicionar.cpf.replace(/[^\w\s]/gi, ''),
                    "idModuloAnalise": 0,
                    "cargo": {
                        "idCargo": 0,
                        "nomeCargo": this.nomeacaoParaAdicionar.nomeCargo
                    },
                    "grupoCargoModel": {
                        "idGrupoCargo": 0,
                        "dsGrupoCargo": this.nomeacaoParaAdicionar.dsGrupoCargo
                    },
                    "checked": true
                };

                let vinculoNomeacaoTemp = this.listaTiposVinculos.filter((vinculoNomeacao) => this.nomeacaoParaAdicionar.dsGrupoCargo == vinculoNomeacao.dsGrupoCargo)[0];
                let cargoNomeacaoTemp = this.listaCargo.filter((cargoNomeacao) => this.nomeacaoParaAdicionar.nomeCargo == cargoNomeacao.nomeCargo)[0];

                if (vinculoNomeacaoTemp != null) {
                    nomeacaoNovo.grupoCargoModel.idGrupoCargo = vinculoNomeacaoTemp.idGrupoCargo;
                }

                if (cargoNomeacaoTemp != null) {
                    nomeacaoNovo.cargo.idCargo = cargoNomeacaoTemp.idCargo;
                }

                if(!this.validaDatas(nomeacaoNovo, true)){
                    return;
                }

                if(!this.validaCargoComissionado(nomeacaoNovo, true)){
                    return;
                }                

                /*
                if (this.temCadastroComDatasConflitantes(nomeacaoNovo)) {
                    
                    this.alertService.mostraAlerta("Não foi possível adicionar o registro", 
                    "Foi identificado um conflito no período de nomeação/contratação relacionado ao CPF " + this.cpf_mask(nomeacaoNovo.cpf) + "!");
                
                } else {
                */    

                    if (this.objetoEdit) {
                        let index = this.listaDados.indexOf(this.objetoEdit);
                        this.listaDados.splice(index, 1);
                        this.listEdit.push(this.objetoEdit);
                    }
                    
                    this.selecionarTodosChecked = false;
                    this.listaDados.push(nomeacaoNovo);
                    this.filtrar();

                    this.objetoEdit = null;

                    this.nomeacaoParaAdicionar.nomeCargo =
                        this.nomeacaoParaAdicionar.dsGrupoCargo =
                        this.nomeacaoParaAdicionar.dsNome =
                        this.nomeacaoParaAdicionar.setorLocacao =
                        this.nomeacaoParaAdicionar.cpf = '';

                    this.nomeacaoParaAdicionar.dtEdital =
                        this.nomeacaoParaAdicionar.dtResultado =
                        this.nomeacaoParaAdicionar.dtHomologacao =
                        this.nomeacaoParaAdicionar.dtExoneracao =
                        this.nomeacaoParaAdicionar.dtContratacao =
                        this.nomeacaoParaAdicionar.dtDemissao =
                        this.nomeacaoParaAdicionar.dtNomeacao = null;

                    let copy = {
                        dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                        monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                        dateFormat: 'dd/mm/yyyy',
                        todayBtnTxt: 'Hoje',
                        firstDayOfWeek: 'su',
                        disableWeekends: false,
                        editableDateField: true,
                        openSelectorOnInputClick: true,
                        showClearDateBtn: false,
                        componentDisabled: false,
                        openSelectorTopOfInput: true,
                        showSelectorArrow: false
                    };

                    this.myDatePickerResultadoOptions = copy;
                    this.myDatePickerHomologacaoOptions = copy;
                    this.myDatePickerNomeacaoOptions = copy;
                    this.myDatePickerExoneracaoOptions = copy;
                    this.myDatePickerDemissaoOptions = copy;
                //}
            } else {
                this.alertService.mostraAlerta("", "Campos obrigatórios não preenchidos.");
            }
        } else {
            this.alertService.mostraAlerta("", "O CPF informado é inválido.");
        }
    }

    removerVinculo(item, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);
                    this.filtrar();

                    if (item.idQuadroNomeacaoCargos != 0) {
                        this.deletarQuadroNomeacao(item.idQuadroNomeacaoCargos);
                    }
                }
            });
        } else {
            if (item.idQuadroNomeacaoCargos != 0) {
                this.deletarQuadroNomeacao(item.idQuadroNomeacaoCargos);
            }
        }
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    carregarQuadroAnoAnterior() {

        this.alertService.mostraModalConfirmacao("Carregar Quadro do Ano Anterior", 
            "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
            "<br />Deseja continuar a carregar o quadro do ano anterior mesmo assim?", 
            callback => {            
                if (callback) {
                    this.alertService.mostraAlerta("Esta operação pode demorar um tempo.", 
                        "Ao finalizar a operação saia da tela e retorne.");

                    this.pessoalService.listarQuadroNomeacaoAnterior().subscribe(data => {
                        this.listaDados = data;
                        this.filtrar();
                        this.exibirBotaoCarregarQuadroAnterior = true;
                        this.selecionarTodosChecked = false;
                    }, error => {
                        console.log("erro: " + error.mensagem);
                        this.exibirBotaoCarregarQuadroAnterior = false;
                    });
                }
            }
        );

    }

   
    salvarTudo() {

        this.loading = true;

        let tempVinculo = null;
        let tempCargo = null;
        let msgErro = '';
        let constPularLinhaHTML = "<br>";

        this.listEdit.forEach(item => {
            this.removerVinculo(item, true);
        });

        this.listEdit = [];

        for (let j = 0; j < this.listaDados.length; j++) {

            tempVinculo = this.listaTiposVinculos.filter((vinculo) => this.listaDados[j].grupoCargoModel.dsGrupoCargo.trim().toUpperCase() == vinculo.dsGrupoCargo.trim().toUpperCase())[0];
            if (!tempVinculo) {
                msgErro += '- Vínculo do CPF ' + this.cpf_mask(this.listaDados[j].cpf) + " não encontrado. Necessário editar o item." + constPularLinhaHTML;
            }

            tempCargo = this.listaCargo.filter((cargo) => this.listaDados[j].cargo.nomeCargo.trim().toUpperCase() == cargo.nomeCargo.trim().toUpperCase())[0];
            if (!tempCargo) {
                msgErro += '- Cargo do CPF ' + this.cpf_mask(this.listaDados[j].cpf) + " não cadastrado ou inativo. Necessário editar o item." + constPularLinhaHTML;
            }

            if (this.listaDados[j].cpf) {
                this.listaDados[j].cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
            }
        }

        if (msgErro == '') {
            this.pessoalService.salvarQuadroNomeacao(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.carregarDados();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
                this.loading = false;
            });
        } else {
            this.alertService.mostraAlerta("Ocorreu um erro ao salvar", msgErro);
            this.loading = false;
        }
    }

    salvarSelecionados() {

        this.loading = true;

        let tempVinculo = null;
        let tempCargo = null;
        let msgErro = '';
        let constPularLinhaHTML = "<br>";

        this.listEdit.forEach(item => {
            this.removerVinculo(item, true);
        });

        this.listEdit = [];

        let listaSelecionada = this.listaFiltrada.filter(item => item.checked);

        for (let j = 0; j < listaSelecionada; j++) {

            tempVinculo = this.listaTiposVinculos.filter((vinculo) => listaSelecionada[j].grupoCargoModel.dsGrupoCargo.trim().toUpperCase() == vinculo.dsGrupoCargo.trim().toUpperCase())[0];
            if (!tempVinculo) {
                msgErro += '- Vínculo do CPF ' + this.cpf_mask(listaSelecionada[j].cpf) + " não encontrado. Necessário editar o item." + constPularLinhaHTML;
            }

            tempCargo = this.listaCargo.filter((cargo) => listaSelecionada[j].cargo.nomeCargo.trim().toUpperCase() == cargo.nomeCargo.trim().toUpperCase())[0];
            if (!tempCargo) {
                msgErro += '- Cargo do CPF ' + this.cpf_mask(listaSelecionada[j].cpf) + " não cadastrado ou inativo. Necessário editar o item." + constPularLinhaHTML;
            }

            if (listaSelecionada[j].cpf) {
                listaSelecionada.cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
            }
        }

        if (msgErro == '') {
            this.pessoalService.salvarQuadroNomeacao(listaSelecionada, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.carregarDados();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
                this.loading = false;
            });
        } else {
            this.alertService.mostraAlerta("Ocorreu um erro ao salvar", msgErro);
            this.loading = false;
        }

    }

    salvar(){
        let qtdeSelecionados = 0; 
        this.listaFiltrada.forEach(item => qtdeSelecionados += item.checked);
        
        if(qtdeSelecionados > 0){
            this.salvarSelecionados();
        } else {
            this.salvarTudo();
        }


    }

    deletarQuadroNomeacao(idQuadroNomeacaoCargos) {
        this.loading = true;

        this.pessoalService.deletarQuadroNomeacao(idQuadroNomeacaoCargos).subscribe(data => {
            this.loading = false;
        }, error => {
            this.loading = false;
            this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir:" + error);
        })
    }
    
    excluirSelecionados(){

        let qtdeSelecionados = 0; 
        this.listaFiltrada.forEach(item => qtdeSelecionados += item.checked);
        
        if(qtdeSelecionados == 0) {
            this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
            return;
        }

        let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

        this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
            "Deseja continuar com a exclusão de " 
                + registrosTexto + "<br/>" 
                + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
            callback => {            
                if (callback) {
                    this.loading = true;
                                        
                    let listaId = this.listaFiltrada
                        .filter(item => item.checked)
                        .map(item => item.idQuadroNomeacaoCargos);
                    
                    this.pessoalService.deletarLista(listaId).subscribe(data => {
                        this.loading = false;
                        this.carregarDados();
                        this.alertService.mostraAlerta("", data.mensagem);
                    }, error => {
                        this.loading = false;
                        this.carregarDados();
                        this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                    });
                }
            }
        );        
    }

    finalizar() {
        let idAnalise = "";

        let tempVinculo = null;
        let tempCargo = null;
        let msgErro = '';
        let constPularLinhaHTML = "<br>";

        this.listEdit.forEach(item => {
            this.removerVinculo(item, true);
        });

        this.listEdit = [];

        for (let j = 0; j < this.listaDados.length; j++) {

            let pessoa = this.listaDados[j];

            if(!pessoa.cpf) {
                msgErro += "- Registro sem CPF. Necessário editar o item." + constPularLinhaHTML;
            } else if(!this.validarCPF(pessoa.cpf)) {
                msgErro += '- CPF ' + this.cpf_mask(pessoa.cpf) + " inválido. Necessário editar o item." + constPularLinhaHTML;
            }

            if(!pessoa.dsNome) {
                msgErro += '- CPF ' + this.cpf_mask(pessoa.cpf) + " com registro sem Nome. Necessário editar o item." + constPularLinhaHTML;
            }

            tempVinculo = this.listaTiposVinculos.filter((vinculo) => pessoa.grupoCargoModel.dsGrupoCargo == vinculo.dsGrupoCargo)[0];
            if (!tempVinculo) {
                msgErro += '- Vínculo do CPF ' + this.cpf_mask(pessoa.cpf) + " não encontrado. Necessário editar o item." + constPularLinhaHTML;
            }

            tempCargo = this.listaCargo.filter((cargo) => pessoa.cargo.nomeCargo.trim() == cargo.nomeCargo.trim())[0];
            if (!tempCargo) {
                msgErro += '- Cargo do CPF ' + this.cpf_mask(pessoa.cpf) + " não cadastrado ou inativo. Necessário editar o item." + constPularLinhaHTML;
            }

            if (pessoa.grupoCargoModel.dsGrupoCargo == 'Terceirizados') {
                if (pessoa.dtContratacao == '') {
                    msgErro += '- Data Contratação não verificada em registro de CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item." + constPularLinhaHTML;
                } 
            } else {
                if (pessoa.dtNomeacao == '') {
                    msgErro += '- DOE Nomeação não verificada em registro de CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item." + constPularLinhaHTML;
                }
            }

            if(!this.validaDatas(pessoa, false)){
                msgErro += '- Data inválida relacionada ao CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item." + constPularLinhaHTML;
            }

            if(!this.validaCargoComissionado(pessoa, false)){
                msgErro += '- Inconsistência em Cargo Comissionado relacionado ao CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item." + constPularLinhaHTML;
            }                

            /*
            if (this.temCadastroComDatasConflitantes(pessoa)) {
                msgErro += '- Período de nomeação/contratação inconsistente relacionado ao CPF ' + this.cpf_mask(pessoa.cpf) + ". Necessário editar o item." + constPularLinhaHTML;
            }
            */

            if (pessoa.cpf) {
                pessoa.cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
            }

        }

        if (msgErro == '') {
            if (this.listaDados) {
                this.pessoalService.finalizarQuadroNomeacao(this.listaDados, this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                    this.voltarParaPessoal();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
                });
            
            } else {
                this.alertService.mostraAlerta("Ocorreu um erro ao finalizar", msgErro);
            }
        }
    }

    onDataEditalChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.nomeacaoParaAdicionar.dtEdital = new Date(event.jsdate).toLocaleDateString('pt-br');
        } else {
            this.nomeacaoParaAdicionar.dtEdital = '';
        }
    }

    getCopyOfResultadoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerResultadoOptions));
    }

    onDataResultadoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.nomeacaoParaAdicionar.dtResultado = new Date(event.jsdate).toLocaleDateString('pt-br');
        } else {
            this.nomeacaoParaAdicionar.dtResultado = '';
        }
    }

    getCopyOfHomologacaoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerHomologacaoOptions));
    }

    onDataHomologacaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.nomeacaoParaAdicionar.dtHomologacao = new Date(event.jsdate).toLocaleDateString('pt-br');
        } else {
            this.nomeacaoParaAdicionar.dtHomologacao = '';
        }
    }

    getCopyOfNomeacaoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerNomeacaoOptions));
    }

    onDataNomeacaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.nomeacaoParaAdicionar.dtNomeacao = new Date(event.jsdate).toLocaleDateString('pt-br');            
        }
        else {
            this.nomeacaoParaAdicionar.dtNomeacao = '';
        }
    }

    getCopyOfExoneracaoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerExoneracaoOptions));
    }

    onDataExoneracaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.nomeacaoParaAdicionar.dtExoneracao = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
        else {
            this.nomeacaoParaAdicionar.dtExoneracao = '';
        }
    }

    onDataContratacaoChanged(event: IMyDateModel) {
        if (event.formatted !== '') {
            this.nomeacaoParaAdicionar.dtContratacao = new Date(event.jsdate).toLocaleDateString('pt-br');
        } else {
            this.nomeacaoParaAdicionar.dtContratacao = '';
        }
    }

    getCopyOfDemissaoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerDemissaoOptions));
    }

    onDataDemissaoChanged(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.nomeacaoParaAdicionar.dtDemissao = '';
        }
        else {
            this.nomeacaoParaAdicionar.dtDemissao = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    editar(item) {

        this.nomeacaoParaAdicionar.nomeCargo = item.cargo.nomeCargo;
        this.nomeacaoParaAdicionar.dsGrupoCargo = item.grupoCargoModel.dsGrupoCargo;
        this.nomeacaoParaAdicionar.dsNome = item.dsNome;
        this.nomeacaoParaAdicionar.setorLocacao = item.setorLocacao;
        this.nomeacaoParaAdicionar.cpf = item.cpf;

        if (item.dtEdital) {
            this.nomeacaoParaAdicionar.dtEdital = item.dtEdital;
        } else {
            this.nomeacaoParaAdicionar.dtEdital = '';
        }

        if (item.dtResultado) {
            this.nomeacaoParaAdicionar.dtResultado = item.dtResultado;
        } else {
            this.nomeacaoParaAdicionar.dtResultado = '';
        }

        if (item.dtHomologacao) {
            this.nomeacaoParaAdicionar.dtHomologacao = item.dtHomologacao;
        } else {
            this.nomeacaoParaAdicionar.dtHomologacao = '';
        }

        if (item.dtNomeacao) {
            this.nomeacaoParaAdicionar.dtNomeacao = item.dtNomeacao;
        } else {
            this.nomeacaoParaAdicionar.dtNomeacao = '';
        }

        if (item.dtExoneracao) {
            this.nomeacaoParaAdicionar.dtExoneracao = item.dtExoneracao;
        } else {
            this.nomeacaoParaAdicionar.dtExoneracao = '';
        }

        if (item.dtContratacao) {
            this.nomeacaoParaAdicionar.dtContratacao = item.dtContratacao;
        } else {
            this.nomeacaoParaAdicionar.dtContratacao = '';
        }

        if (item.dtDemissao) {
            this.nomeacaoParaAdicionar.dtDemissao = item.dtDemissao;
        } else {
            this.nomeacaoParaAdicionar.dtDemissao = '';
        }

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Pessoal - Composição do Quadro de Pessoal", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Vínculo", dataKey: "vinculo" },
            { title: "Cargo/Posto de Trabalho", dataKey: "cargo" },
            { title: "Nome", dataKey: "nome" },
            { title: "CPF", dataKey: "cpf" },
            { title: "DOE Edital", dataKey: "edital" },
            { title: "DOE Resultado", dataKey: "resultado" },
            { title: "DOE Homologação", dataKey: "homologacao" },
            { title: "DOE Nomeação", dataKey: "nomeacao" },
            { title: "DOE Exoneração", dataKey: "exoneracao" },
            { title: "Admissão", dataKey: "admissao" },
            { title: "Demissão", dataKey: "demissao" },
            { title: "Setor de Lotação", dataKey: "setor" }
        ];

        let rows = [];

        this.listaDados.forEach(element => {

            var item = {
                "vinculo": element.grupoCargoModel.dsGrupoCargo != null ? element.grupoCargoModel.dsGrupoCargo : "",
                "cargo": element.cargo.nomeCargo != null ? element.cargo.nomeCargo : "",
                "nome": element.dsNome != null ? element.dsNome : "",
                "cpf": element.cpf != null ? this.cpf_mask(element.cpf) : "",
                "edital": element.dtEdital != null ? element.dtEdital : "",
                "resultado": element.dtResultado != null ? element.dtResultado : "",
                "homologacao": element.dtHomologacao != null ? element.dtHomologacao : "",
                "nomeacao": element.dtNomeacao != null ? element.dtNomeacao : "",
                "exoneracao": element.dtExoneracao != null ? element.dtExoneracao : "",
                "admissao": element.dtContratacao != null ? element.dtContratacao : "",
                "demissao": element.dtDemissao != null ? element.dtDemissao : "",
                "setor": element.setorLocacao != null ? element.setorLocacao : ""
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: {
                top: 30,
                left: 5
            },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'wrap',
                fontSize: 6
            },
            columnStyles: {
                text: { columnWidth: 'auto' },
                vinculo: { columnWidth: 35 },
                cargo: { columnWidth: 35 },
                nome: { columnWidth: 35 },
                cpf: { columnWidth: 20 },
                edital: { columnWidth: 16 },
                resultado: { columnWidth: 16 },
                homologacao: { columnWidth: 16 },
                nomeacao: { columnWidth: 16 },
                exoneracao: { columnWidth: 16 },
                admissao: { columnWidth: 16 },
                demissao: { columnWidth: 16 },
                setor: { columnWidth: 35 }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('pessoal_composicao_quadro_pessoal.pdf');
    }

    filtrar() {
        if (this.filtros.cpf.length > 0) {
          this.listaFiltrada = this.listaDados.filter(dado => {
            return dado.cpf.includes(this.filtros.cpf.replace(/[^\w\s]/gi, ''));
          });
        } else {
            this.listaFiltrada = this.listaDados;
        }
    }

    temCadastroComDatasConflitantes(nomeacaoNovo): boolean {

        let objetoEditIndex = -1;
        let dataInicioNovo: Date;
        let dataFimNovo: Date;
        let dataInicio: Date;
        let dataFim: Date;
        let dataSplit: any[];

       
        if (this.objetoEdit) {
            objetoEditIndex = this.listaDados.indexOf(this.objetoEdit); 
        }
        
        if (nomeacaoNovo.grupoCargoModel.dsGrupoCargo == 'Terceirizados') {
            if(nomeacaoNovo.dtContratacao) {
                dataSplit = nomeacaoNovo.dtContratacao.split("/");
                dataInicioNovo = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
            } else {
                dataInicioNovo = null;
            }
            if(nomeacaoNovo.dtDemissao) {
                dataSplit = nomeacaoNovo.dtDemissao.split("/");
                dataFimNovo = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
            } else {
                dataFimNovo = null;    
            }         
        } else {
            if(nomeacaoNovo.dtNomeacao) {
                dataSplit = nomeacaoNovo.dtNomeacao.split("/");
                dataInicioNovo = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
            } else {
                dataInicioNovo = null;
            }
            if(nomeacaoNovo.dtExoneracao) {
                dataSplit = nomeacaoNovo.dtExoneracao.split("/");
                dataFimNovo = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
            } else {
                dataFimNovo = null;    
            }        
        }

        for (let i = 0; i < this.listaDados.length; i++ ){
            
            let pessoa = this.listaDados[i];
            
            if(objetoEditIndex == -1 && nomeacaoNovo !== pessoa || objetoEditIndex != -1 && objetoEditIndex != i){

                if(pessoa.cpf.replace(/[^\w\s]/gi, '') == nomeacaoNovo.cpf.replace(/[^\w\s]/gi, '')){

                    if (pessoa.grupoCargoModel.dsGrupoCargo == 'Terceirizados') {                       
                        if(pessoa.dtContratacao) {
                            dataSplit = pessoa.dtContratacao.split("/");
                            dataInicio = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
                        } else {
                            dataInicio = null;
                        }
                        if(pessoa.dtDemissao) {
                            dataSplit = pessoa.dtDemissao.split("/");
                            dataFim = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
                        } else {
                            dataFim = null;    
                        }         
                    } else {
                        if(pessoa.dtNomeacao) {
                            dataSplit = pessoa.dtNomeacao.split("/");
                            dataInicio = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
                        } else {
                            dataInicio = null;
                        }
                        if(pessoa.dtExoneracao) {
                            dataSplit = pessoa.dtExoneracao.split("/");
                            dataFim = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
                        } else {
                            dataFim = null;    
                        }
                    }

                    if(this.temCargoAcumulavelComComissionado(nomeacaoNovo) && pessoa.grupoCargoModel.dsGrupoCargo == 'Comissionados'
                        || this.temCargoAcumulavelComComissionado(pessoa) && nomeacaoNovo.grupoCargoModel.dsGrupoCargo == 'Comissionados'
                        || nomeacaoNovo.grupoCargoModel.dsGrupoCargo == 'Contratados' && pessoa.grupoCargoModel.dsGrupoCargo == 'Contratados'){
                            continue;
                    }

                    if (dataFimNovo && dataFim) {
                        if (dataFimNovo >= dataInicio && dataInicioNovo <= dataFim){
                            return true;
                        }                    
                    } else if (dataFimNovo && !dataFim) {
                        if(dataFimNovo >= dataInicio){
                            return true;
                        }
                    } else if (!dataFimNovo && dataFim) {
                        if(dataInicioNovo <= dataFim){
                            return true;
                        }
                    } else {
                        return true;
                    }


                }
            }
        };
        
        return false;  
    }

    validaDatas(nomeacaoNovo: any, mostrarMensagens: boolean) {
        
        if (nomeacaoNovo.grupoCargoModel.dsGrupoCargo == 'Terceirizados') {

            if(this.periodoInvalido(nomeacaoNovo.dtContratacao, nomeacaoNovo.dtDemissao, false)) {
                if(mostrarMensagens) {
                    this.alertService.mostraAlerta("Data inválida", 
                            "Data Demissão deve ser posterior à Data Contratação.");
                }                
                return false;        
            }

        } else {

            if(this.periodoInvalido(nomeacaoNovo.dtEdital, nomeacaoNovo.dtResultado, false)) {
                if(mostrarMensagens) {
                    this.alertService.mostraAlerta("Data inválida", 
                            "DOE Resultado do Concurso deve ser posterior à DOE Edital.");                    
                }
                return false;        
            }
    
            if(this.periodoInvalido(nomeacaoNovo.dtEdital, nomeacaoNovo.dtHomologacao, false)) {
                if(mostrarMensagens) {
                    this.alertService.mostraAlerta("Data inválida", 
                            "DOE Homologação do Concurso deve ser posterior à DOE Edital.");                    
                }
                return false;
            }
    
            if(this.periodoInvalido(nomeacaoNovo.dtResultado, nomeacaoNovo.dtHomologacao, true)) {
                if(mostrarMensagens) {                    
                    this.alertService.mostraAlerta("Data inválida", 
                            "DOE Homologação do Concurso deve ser posterior ou igual a DOE Resultado do Concurso.");
                }
                return false;
            }
    
            if(this.periodoInvalido(nomeacaoNovo.dtHomologacao, nomeacaoNovo.dtNomeacao, true)) {
                if(mostrarMensagens) {    
                    this.alertService.mostraAlerta("Data inválida", 
                            "DOE Nomeação deve ser posterior ou igual a DOE Homologação do Concurso.");
                }
                return false;
            }
             
            if(this.periodoInvalido(nomeacaoNovo.dtNomeacao, nomeacaoNovo.dtExoneracao, false)) {
                if(mostrarMensagens) {    
                    this.alertService.mostraAlerta("Data inválida", 
                            "DOE Exoneração/Afastamento/Cessão deve ser posterior a DOE Nomeação.");
                }
                return false;        
            }

        }

        return true;
    }

    periodoInvalido(data1, data2, podemSerIguais) {
        let dataSplit: any[];
        let d1: Date;
        let d2: Date;

        if(!data1 || !data2){
            return false;
        }

        dataSplit = data1.split("/");
        d1 = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);

        dataSplit = data2.split("/");
        d2 = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);

        if (podemSerIguais){
            if (d2 < d1) {
                return true;
            }
        } else {
            if (d2 <= d1) {
                return true;
            }
        }        

        return false;
    }

    validaCargoComissionado(nomeacaoNovo: any, mostrarMensagens: boolean) {

        let objetoEditIndex = -1;
        let dataInicioNovo: Date;
        let dataInicio: Date;
        let dataFimNovo: Date;
        let dataFim: Date;
        let dataSplit: any[];

        if (this.objetoEdit) {
            objetoEditIndex = this.listaDados.indexOf(this.objetoEdit); 
        }

        dataSplit = nomeacaoNovo.dtNomeacao.split("/");
        dataInicioNovo = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);

        if(nomeacaoNovo.dtExoneracao){
            dataSplit = nomeacaoNovo.dtExoneracao.split("/");
            dataFimNovo = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
        }
        /*
        if(nomeacaoNovo.grupoCargoModel.dsGrupoCargo == 'Comissionados') {

            let encontrouCargoCompativel = false;

            for (let i = 0; i < this.listaDados.length; i++ ){
            
                let pessoa = this.listaDados[i];
    
                if(objetoEditIndex == -1 && nomeacaoNovo !== pessoa || objetoEditIndex != -1 && objetoEditIndex != i){
    
                    if(pessoa.cpf.replace(/[^\w\s]/gi, '') == nomeacaoNovo.cpf.replace(/[^\w\s]/gi, '')){

                        if(this.temCargoAcumulavelComComissionado(pessoa) && pessoa.dtNomeacao) {

                            dataSplit = pessoa.dtNomeacao.split("/");
                            dataInicio = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);

                            if(dataInicioNovo >= dataInicio){ 
                                
                                if(pessoa.dtExoneracao) {

                                    dataSplit = pessoa.dtExoneracao.split("/");
                                    dataFim = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);

                                    if(dataFimNovo && dataFimNovo <= dataFim){
                                        encontrouCargoCompativel = true;
                                        break;    
                                    }

                                } else {
                                    encontrouCargoCompativel = true;
                                    break;
                                }                                
                                
                            }
                        }
                    }
                }
            } 

            if(!encontrouCargoCompativel) {
                if(mostrarMensagens) {    
                    this.alertService.mostraAlerta("Não foi possível adicionar o registro", 
                        "Não foi encontrado um vínculo compatível com o Cargo Comissionado relacionado ao CPF " + this.cpf_mask(nomeacaoNovo.cpf) + "!");
                }
            }
            
            return encontrouCargoCompativel;
        } 
        
        if(this.temCargoAcumulavelComComissionado(nomeacaoNovo)) {

            let encontrouComissioadoIncompativel = false;

            for (let i = 0; i < this.listaDados.length; i++ ){
            
                let pessoa = this.listaDados[i];
    
                if(objetoEditIndex == -1 && nomeacaoNovo !== pessoa || objetoEditIndex != -1 && objetoEditIndex != i){
    
                    if(pessoa.cpf.replace(/[^\w\s]/gi, '') == nomeacaoNovo.cpf.replace(/[^\w\s]/gi, '')){

                        if(pessoa.grupoCargoModel.dsGrupoCargo == 'Comissionados' && pessoa.dtNomeacao && !pessoa.dtExoneracao) { // achou cargo comissionado em aberto

                            dataSplit = pessoa.dtNomeacao.split("/");
                            dataInicio = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]); // nomeação do comissionado

                            if(dataInicio < dataInicioNovo || nomeacaoNovo.dtExoneracao){ // comissionado com nomeação inválida ou cargo com exoneração
                                encontrouComissioadoIncompativel = true;
                                break;
                            }
                        }

                    }
                }
            }

            if(encontrouComissioadoIncompativel) {
                if(mostrarMensagens) {    
                    this.alertService.mostraAlerta("Não foi possível adicionar o registro", 
                        "Foi identificado um Cargo Comissionado sem exoneração com nomeação incompatível relacionado ao CPF " + this.cpf_mask(nomeacaoNovo.cpf) + "!");
                }
            }
            
            return !encontrouComissioadoIncompativel;

        } */   

        return true;
    }

    temCargoAcumulavelComComissionado(pessoa) {
        return pessoa.grupoCargoModel.dsGrupoCargo == 'Contratados'
                || pessoa.grupoCargoModel.dsGrupoCargo == 'Servidores Cedidos de Outros Órgãos'
                || pessoa.grupoCargoModel.dsGrupoCargo == 'Servidores Efetivos/Empregados Públicos'
                || pessoa.grupoCargoModel.dsGrupoCargo == 'Vinculados a Contratos de Gestão';
    }

    selecionarTodos(){
        setTimeout(()=>{
            this.listaDados.forEach(
                item => item.checked = this.selecionarTodosChecked);            
        });
    }

    selecionarItem(){
        const totalItems = this.listaDados.length;
        let checked = 0;
        this.listaDados.map(obj => {
            if (obj.checked) checked++;
        });
        this.selecionarTodosChecked = checked == totalItems;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/quadro-nomeacao-cargos/quadro-nomeacao-cargos.ts